import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TextField } from '~common/components/form/field-text.component';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';
import { EmailField } from '~common/components/form/email-field.component';
import { Span } from '~common/components/span.component';

export const ClientUserFields: React.FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <FieldGroupTitle>{t('manageClients.createUser.title')}</FieldGroupTitle>
      <FieldContainer>
        <Row>
          <RestrictBox>
            <TextField name={'firstName'} label={t('manageClients.createUser.firstName')} />
          </RestrictBox>
          <RestrictBox>
            <TextField name={'lastName'} label={t('manageClients.createUser.lastName')} />
          </RestrictBox>
        </Row>
        <Row>
          <RestrictBox>
            <EmailField />
          </RestrictBox>
        </Row>
      </FieldContainer>
    </Container>
  );
};

const Container = styled(Column)`
  width: 100%;
`;

const FieldContainer = styled(Column)`
  width: 100%;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
`;

const Row = styled(Box)`
  margin-top: 24px;
`;

const FieldGroupTitle = styled(Span)`
  font-weight: bold;
  font-size: 22px;
  line-height: 22px;
  margin: 18px 0 12px;
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
  margin: 0 12px;
`;



// WEBPACK FOOTER //
// ./view/components/clients/client-user-fields.component.tsx